import { render, staticRenderFns } from "./ShowTags.vue?vue&type=template&id=0c748e60&scoped=true"
import script from "./ShowTags.vue?vue&type=script&lang=js"
export * from "./ShowTags.vue?vue&type=script&lang=js"
import style0 from "./ShowTags.vue?vue&type=style&index=0&id=0c748e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c748e60",
  null
  
)

export default component.exports